import { TeamMember, TeamSummary as TeamSummaryType, TeamCertificationSummary } from '../types/teamSummary';
import { getTeamSummary as getTeamSummaryFromService, suspendUser, activateUser, removeUser } from './teamService';
import { logTrace } from './loggerService';

// Interfaces
export interface TeamWidgetData {
  seats: {
    usedSeats: number;
    totalSeats: number;
  };
  metrics: {
    activeUsers: number;
    totalUsers: number;
    totalCoursesCompleted: number;
  };
  report: {
    certifications: TeamCertificationSummary[];
  };
}

// Team Summary Service
export class TeamSummary {
  // Public Methods - Data Retrieval

  async getTeamSummary(): Promise<TeamSummaryType> {
    return await getTeamSummaryFromService();
  }

  // Public Methods - Team Actions
  async suspend(member: TeamMember): Promise<void> {
    if (!member.id) {
      logTrace('Cannot suspend member: ID is missing', undefined, {
        member: member,
        memberKeys: Object.keys(member)
      });
      throw new Error(`Cannot suspend member: ID is missing. Member: ${JSON.stringify(member)}`);
    }
    await suspendUser(member.id);
  }

  async activate(member: TeamMember): Promise<void> {
    if (!member.id) {
      logTrace('Cannot activate member: ID is missing', undefined, {
        member: member,
        memberKeys: Object.keys(member)
      });
      throw new Error(`Cannot activate member: ID is missing. Member: ${JSON.stringify(member)}`);
    }
    await activateUser(member.id);
  }

  async remove(member: TeamMember): Promise<void> {
    if (!member.id) {
      logTrace('Cannot remove member: ID is missing', undefined, {
        member: member,
        memberKeys: Object.keys(member)
      });
      throw new Error(`Cannot remove member: ID is missing. Member: ${JSON.stringify(member)}`);
    }
    await removeUser(member.id);
  }

  async printDownload(format: 'pdf' | 'csv' | 'excel' = 'pdf'): Promise<void> {
    // TODO: Implement print/download functionality
  }

  async viewReport(): Promise<void> {
    // TODO: Implement view report functionality
  }
}

// Export Singleton
export const teamSummary = new TeamSummary();
